import _createForOfIteratorHelper from "/usr/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import { trackEvents } from "@/common/events/events";
export var getPostBreadcrumb = function getPostBreadcrumb(t, createUrl) {
  return function (postData) {
    var _postData$details, _postData$details$det, _postData$details$det2, _postData$details2, _postData$details2$de, _postData$details2$de2;
    var _ref = (postData === null || postData === void 0 ? void 0 : postData.analytics) || {},
      brand = _ref.brand,
      model = _ref.model,
      year = _ref.year;
    var brandSlug = brand === null || brand === void 0 ? void 0 : brand.slugify();
    var modelSlug = model === null || model === void 0 ? void 0 : model.slugify();
    var breadcrumbLinks = [{
      title: t("سيارات و مركبات", {
        ns: "web_post_view"
      }),
      link: createUrl("/autos"),
      event: function event() {
        return trackEvents("browse_cars", {
          referral_location: "Post View",
          category_path: "autos>all"
        });
      }
    }, {
      title: postData === null || postData === void 0 ? void 0 : (_postData$details = postData.details) === null || _postData$details === void 0 ? void 0 : (_postData$details$det = _postData$details.details_card) === null || _postData$details$det === void 0 ? void 0 : (_postData$details$det2 = _postData$details$det.make) === null || _postData$details$det2 === void 0 ? void 0 : _postData$details$det2.name,
      link: createUrl("/autos/".concat(brandSlug)),
      event: function event() {
        return trackEvents("browse_cars", {
          referral_location: "Post View",
          browse_variant: "make",
          variant_value: brandSlug,
          category_path: "autos>".concat(brandSlug)
        });
      }
    }, {
      title: postData === null || postData === void 0 ? void 0 : (_postData$details2 = postData.details) === null || _postData$details2 === void 0 ? void 0 : (_postData$details2$de = _postData$details2.details_card) === null || _postData$details2$de === void 0 ? void 0 : (_postData$details2$de2 = _postData$details2$de.model) === null || _postData$details2$de2 === void 0 ? void 0 : _postData$details2$de2.name,
      link: createUrl("/autos/".concat(brandSlug, "/").concat(modelSlug)),
      event: function event() {
        return trackEvents("browse_cars", {
          referral_location: "Post View",
          browse_variant: "model",
          variant_value: modelSlug,
          category_path: "autos>".concat(brandSlug, ">").concat(modelSlug)
        });
      }
    }, {
      title: "".concat(year),
      link: createUrl("/autos/".concat(brandSlug, "/").concat(modelSlug, "/").concat(year)),
      event: function event() {
        return trackEvents("browse_cars", {
          referral_location: "Post View",
          browse_variant: "year",
          variant_value: year,
          category_path: "autos>".concat(brandSlug, ">").concat(modelSlug, ">").concat(year)
        });
      }
    }];
    return breadcrumbLinks;
  };
};
export function extractPostId(text) {
  if (!text) return null;

  // Split the text by non-word characters
  var parts = decodeURIComponent(text).split(/[\W_]+/);
  var maxPostId = null;

  // Iterate through parts to find the maximum valid post ID
  var _iterator = _createForOfIteratorHelper(parts),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var part = _step.value;
      // Convert part to a number
      var num = Number(part);

      // Check if it's a valid number and not a year in the range 2006-2024
      if (!isNaN(num) && (num < 2006 || num > 2024)) {
        if (maxPostId === null || num > maxPostId) {
          maxPostId = num;
        }
      }
    }

    // Return the maximum valid post ID found, or null if none found
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return maxPostId;
}